const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* NORBITA: bolsita de selección rápida.
 * El enlace invisible que cubre la tarjeta del producto puede quedar por encima de la bolsita
 * y llevar al producto en vez de abrir el selector de talla. Si el toque cae sobre la bolsita,
 * cancelamos el enlace y abrimos el selector. Si el selector no está disponible en esa página,
 * se deja abrir el producto como antes. */
(function () {
  function selectorDisponible(boton) {
    var opener = boton.closest('modal-opener');
    if (opener) {
      return !!customElements.get('quick-add-modal') && !!document.querySelector(opener.getAttribute('data-modal'));
    }
    return !!boton.closest('product-form') && !!customElements.get('product-form');
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('.quick-add__submit')) return;
      var enlace = e.target.closest('.card__heading a');
      if (!enlace) return;
      var tarjeta = enlace.closest('.card-wrapper');
      var boton = tarjeta && tarjeta.querySelector('.quick-add__submit');
      if (!boton || boton.disabled) return;
      var r = boton.getBoundingClientRect();
      var dentro = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!dentro || !selectorDisponible(boton)) return;
      e.preventDefault();
      e.stopPropagation();
      boton.click();
    },
    true
  );
})();
